<template>
  <li class="GoodsItem">
    <div class="imgBox">
      <img :src="img" alt="商品图片" @click="navTo('/mall/goods/' + id)" />
    </div>
    <div class="goodsInfo">
      <span class="goodsName ellipsis-two" @click="navTo('/mall/goods/' + id)">
        {{ name }}
      </span>

      <span class="price">{{ '¥' + price }}</span>
      <span class="goodsName">
        {{ section.map((el) => el.value).join('-') }}
      </span>
      <div>{{ sku }}</div>
    </div>
  </li>
</template>

<script>
export default {
  name: "GoodsItem",
  props: {
    id: {
      type: [Number, String],
      default: () => "",
    },
    img: {
      type: String,
      default: () => "",
    },
    name: {
      type: String,
      default: () => "",
    },
    price: {
      type: [Number, String],
      default: () => "",
    },
    section: {
      type: [Number, String, Array],
      default: () => "",
    },
    sku: {
      type: [Number, String, Array],
      default: () => "",
    }
  },
  data () {
    return {};
  },
  methods: {
    navTo (route) {
      this.$router.push(route);
    },
  },
};
</script>

<style scoped lang="less">
@import '../assets/css/var.less';
.GoodsItem {
  min-height: 335px;
  overflow: hidden;
  background: #fff;
  // margin-bottom: 8px;
  &:hover {
    img {
      transform: scale(1.05);
    }
  }
  .imgBox {
    width: 100%;
    // height: 266px;
    overflow: hidden;
    padding: 16px;
    box-sizing: border-box;
    img {
      width: 100%;
      height: 200px;
      cursor: pointer;
      transition: transform 0.5s;
    }
  }
  .goodsInfo {
    width: 100%;
    // height: 60px;
    font-size: 14px;
    padding: 0 25px 10px;
    text-align: center;
    .goodsName {
      cursor: pointer;
      // margin-top: 10px;
      margin-bottom: 8px;
      color: #333;
      font-size: 14px;
      &:hover {
        color: @thirdColor;
      }
    }
    .price {
      display: block;
      font-size: 18px;
      color: @falseColor;
      margin-bottom: 8px;
      // font-weight: 600;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/GoodsItem.vue